import { isMobile } from "react-device-detect";

export const scaleStep = isMobile ? 0.1 : 0.05;
export const moveStep = 50;
export const animationDuration = 200;
export const scaleStepsDesktop = 5;
export const scaleStepsTablet = 3;
